import React from "react"

import * as s from "./Facts.module.scss"

export const Facts = ({ data }) => {
  if (!data || !data.facts) return <></>

  const colorClass = color => {
    switch (color) {
      case "#000000":
        return s.Fact__inner___black
        break
      case "#F02937":
        return s.Fact__inner___red
        break
      case "#FFC72C":
        return s.Fact__inner___yellow
        break
      case "#EFEFEF":
        return s.Fact__inner___grey
        break
      case "#FFFFFF":
        return s.Fact__inner___white
        break
    }
  }
  return (
    <div className={s.Facts}>
      <div className={s.Facts__intro}>
        <h4>{data.title}</h4>
        <p>{data.blurb}</p>
      </div>

      {data.facts.map((fact, i) => {
        return (
          <div className={s.Fact} key={i}>
            <div className={`${s.Fact__inner} ${colorClass(fact.blockColor)}`}>
              <div
                className={s.Fact__image}
                style={{
                  background: `url(${fact.image && fact.image.sourceUrl})`,
                }}
              />
              <div className={s.Fact__question}>
                {fact.subTitle && <h5>{fact.subTitle}</h5>}
                <p>{fact.title}</p>
              </div>
              <div
                className={`${s.Fact__reveal} ${
                  !fact.image ? s.Fact__reveal__noImage : ""
                }`}
              >
                <div>
                  <p>{fact.revealText}</p>
                </div>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
